export const uiCapabilities = {
  admin: {
    canDeleteOrder: true,
    canCancelOrder: true,
    canDownloadOrderInvoice: true,
    canDownloadOrderInformationTemplate: true,
    canAccessFilesSection: true,
    canUpdateCustomer: true,
  },

  assistant_admin: {
    canDeleteOrder: true,
    canCancelOrder: true,
    canDownloadOrderInvoice: true,
    canDownloadOrderInformationTemplate: true,
    canAccessFilesSection: true,
    canUpdateCustomer: true,
  },

  order_management_specialist: {
    canDeleteOrder: true,
    canCancelOrder: true,
    canDownloadOrderInvoice: true,
    canDownloadOrderInformationTemplate: true,
    canUpdateCustomer: false,
  },

  order_management_associate: {
    canDeleteOrder: true,
    canCancelOrder: true,
    canDownloadOrderInvoice: false,
    canDownloadOrderInformationTemplate: true,
    canUpdateCustomer: false,
  },

  delivery_associate: {
    canDeleteOrder: false,
    canCancelOrder: false,
    canDownloadOrderInvoice: false,
    canDownloadOrderInformationTemplate: true,
    canUpdateCustomer: false,
  },

  e_commerce_admin: {
    canDeleteOrder: false,
    canCancelOrder: false,
    canDownloadOrderInvoice: false,
    canDownloadOrderInformationTemplate: false,
    canUpdateCustomer: false,
  },

  content_manager: {
    canDeleteOrder: false,
    canCancelOrder: false,
    canDownloadOrderInvoice: false,
    canDownloadOrderInformationTemplate: false,
    canAccessFilesSection: true,
    canUpdateCustomer: false,
  },
};
